// Архив переписки: четыре года Вотсапа заказчика, только чтение.
//
// Записать сюда нельзя и не будет можно: архив наполняется переносом выгрузки, а не руками.
// Правка исторического сообщения означала бы, что архиву нельзя верить как источнику — а он
// существует ровно затем, чтобы на него ссылались: у каждой находки стоит файл и номер строки.
//
// Автор здесь СТРОКА, а не ссылка на человека. В выгрузке сорок семь авторов, и все они записи
// телефонной книги («Марей Мегафон», «Папка», тринадцать голых номеров); сверка с картотекой из
// 314 человек дала ноль совпадений. Показать выдуманное соответствие значило бы соврать в
// каждой строке.

import { request } from '@/shared/api/client';
import { queryString } from '@/shared/api/query';

export interface ArchiveMessage {
  id: string;
  /** Имя чата в выгрузке: «Авансы», «Форма Барк». */
  source_chat: string;
  /** Как автор подписан в источнике. */
  author: string;
  sent_on: string;
  /** Время как в выгрузке, без зоны: часового пояса там нет вовсе. */
  sent_at?: string | null;
  body: string;
  /** «Авансы.txt:66235» — по нему число проверяют в источнике, а не верят нам на слово. */
  source_ref: string;
  /** Сообщение правили после отправки: сумму в нём стоит сверить. */
  edited: boolean;
}

export interface ArchiveSearch {
  items: ArchiveMessage[];
  /** Сколько нашлось ВСЕГО, а не на этой странице. */
  total: number;
  offset: number;
  limit: number;
  /** «Нашлось 1 240 сообщений, показаны с 1 по 50». */
  summary: string;
}

export interface ArchiveChat {
  source_chat: string;
  messages: number;
  first_on: string;
  last_on: string;
  authors: number;
}

export interface ArchiveParams {
  query?: string;
  chat?: string;
  author?: string;
  date_from?: string;
  date_to?: string;
  limit?: number;
  offset?: number;
}

export async function fetchArchive(params: ArchiveParams = {}): Promise<ArchiveSearch> {
  return request<ArchiveSearch>(`/api/v1/chat-archive${queryString({ ...params })}`);
}

export async function fetchArchiveChats(): Promise<{ items: ArchiveChat[]; total: number }> {
  return request<{ items: ArchiveChat[]; total: number }>('/api/v1/chat-archive/chats');
}

export async function fetchArchiveAuthors(
  chat?: string,
): Promise<{ items: string[]; total: number }> {
  return request<{ items: string[]; total: number }>(
    `/api/v1/chat-archive/authors${queryString({ chat })}`,
  );
}
